module.exports = __webpack_public_path__ + "static/media/about4.58a4700b.png";